var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3C2.50781 3 1.5 4.00781 1.5 5.25V18.75C1.5 19.9922 2.50781 21 3.75 21H9.9082C9.66797 20.5254 9.46875 20.0215 9.31641 19.5H3.75C3.33398 19.5 3 19.166 3 18.75V17.3613L8.33203 11.3496L10.0781 13.1836C10.3301 12.7383 10.623 12.3164 10.9512 11.9297L8.29688 9.13477L3 15.0996V5.25C3 4.83398 3.33398 4.5 3.75 4.5H20.25C20.666 4.5 21 4.83398 21 5.25V9.9082C21.5332 10.1836 22.043 10.5059 22.5 10.8867V5.25C22.5 4.00781 21.4922 3 20.25 3H3.75ZM16.5 6C15.6738 6 15 6.67383 15 7.5C15 8.32617 15.6738 9 16.5 9C17.3262 9 18 8.32617 18 7.5C18 6.67383 17.3262 6 16.5 6ZM17.25 10.5C13.5293 10.5 10.5 13.5293 10.5 17.25C10.5 20.9707 13.5293 24 17.25 24C20.9707 24 24 20.9707 24 17.25C24 13.5293 20.9707 10.5 17.25 10.5ZM17.25 12C20.1562 12 22.5 14.3438 22.5 17.25C22.5 20.1562 20.1562 22.5 17.25 22.5C14.3438 22.5 12 20.1562 12 17.25C12 14.3438 14.3438 12 17.25 12ZM16.5 13.5V16.5H13.5V18H16.5V21H18V18H21V16.5H18V13.5H16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImage);
export default __webpack_public_path__ + "static/media/icon-add-image.95ccaaec73e2917ee1b52cd943ac6cde.svg";
export { ForwardRef as ReactComponent };